<template>
  <section class="tabs">
    <van-tabs v-model="active">
      <van-tab title="商品参数">
        <div class="tabs-content-table" v-html="product.desc"></div>
      </van-tab>
      <van-tab title="换新流程">
        <div class="item-content-img"></div>
      </van-tab>
    </van-tabs>
  </section>
</template>

<script>
export default {
  props: ["product"],
  data() {
    return {
      active: 1
    };
  },
  methods: {
  }
};
</script>

<style scoped>
.tabs {
  margin-top: 0.1rem;
  background: #fff;
}
.tabs-content {
  padding: 0.12rem 0;
}
.tabs-content-table{
  min-height: 1.9rem;
  padding:0.1rem 0 0 0;
  }
.tabs-content-table img{max-width: 100%;}
.tabs-content-table table {
  width: 100%;
  font-size: 0.12rem;
}
.tabs-content-table table tr {
  background: #f5f5f5;
}
.tabs-content-table table tr:nth-child(2n) {
  background: #fff;
}
.tabs-content-table table tr td {
  width: 50%;
  padding: 10px;
}
.item-content-img {
  width: 3.48rem;
  height: 1.8rem;
  background: url(../../../assets/image/mobileStepBg.png) no-repeat;
  background-size: 100%;
  margin: 0.2rem 0.1rem 0.1rem 0.1rem;
}
</style>
